export default {
  user: null,
  myTeacherUser: { role: 'teacher' }
}
